import { action } from "typesafe-actions";
import { ChatBotTypes } from "./types";

export const deleteChatBotLinkAuxiliar = (data: any) => action(ChatBotTypes.CHATBOT_DELETE_LINK_AUX_REQ, data);
export const deleteChatBotLinkAuxiliarSuccess = (data: any) => action(ChatBotTypes.CHATBOT_DELETE_LINK_AUX_REQ_SUCCESS, { data });
export const deleteChatBotLinkAuxiliarFailure = (err: any) => action(ChatBotTypes.CHATBOT_DELETE_LINK_AUX_REQ_FAILURE, { err });